<template>
  <article class="article-stand-alone">
    <div class="back-layer">
      <section class="description">
        <slot name="title">
          <h2>
            {{ title }}
          </h2>
        </slot>
        <div class="details mb-4">
          <slot name="details" />
        </div>
      </section>
    </div>
    <div class="content">
      <slot />
    </div>
  </article>
</template>

<script>
export default {
  name: 'QxStandAlone',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss">
.article-stand-alone {
  width: 100%;
  margin: 0 auto;
  .back-layer {
    background-color: $gray-100;
    width: 100%;
  }
  .description {
    width: 60%;
    margin: 0 auto;
    @media (max-width: 1366px) {
      width: 75%;
    }
    @media (max-width: 960px) {
      width: 85%;
    }
    @media (max-width: 766px) {
      width: 95%;
    }
    h2 {
      font-family: $bold-sans-font;
      font-size: 24px;
      padding: 24px 0 24px 5px;
      color: $standalone-black;
    }
    .details {
      font-family: $regular-font;
      font-size: 15px;
      line-height: 24px;
      padding: 0 15px 24px 5px;
      color: $standalone-black;
    }
  }
  .content {
    width: 60%;
    margin: 0 auto;
    @media (max-width: 1366px) {
      width: 75%;
    }
    @media (max-width: 960px) {
      width: 85%;
    }
    @media (max-width: 766px) {
      width: 95%;
    }
  }
}
</style>
